export default __webpack_public_path__ + "static/media/ic_iraq.86db8450.svg";